import CalloutEditing from './callout-editing';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
class CalloutUI extends Plugin {
    init() { }
}
export default class Callout extends Plugin {
    static get requires() {
        return [CalloutEditing, CalloutUI];
    }
}
